// UI-state query keys: component / modal / form state owned by the state hooks,
// NOT server data. Server-data keys live in the per-domain keys files under
// src/react/shared/api/<domain>/keys.ts (Uni-ADR-014). The modal-teardown
// prefix REMOVE_QUERY_ON_MODAL_CLOSE lives here but is also referenced by the
// load query key so that fetch is cleared on modal close.
export default {
  ACQUISITION_CONFIG: 'acquisitionConfig',
  ACQUISITION_TYPE: 'acquisitionType',
  ACQUISITION_VIEW_STACK: 'acquisitionViewStack',
  AVAILABLE_ACQUISITION_TYPES: 'availableAcquisitionTypes',
  DROPBOX_APP: 'dropboxApp',
  SELECTED_INDEX: 'selectedIndex',
  SELECTED_LIMITED_USE_PRODUCT: 'selectedLimitedUseProduct',
  SELECTED_SUBSCRIPTION_OPTION: 'selectedSubscriptionOption',
  SELECTED_ULTRA_PACK: 'selectedUltraPack',
  ALC_ULTRA_PACK: 'alcUltrapack',
  HISTORY_ASSET: 'historyAsset',
  LIMITED_USE_PRODUCTS: 'limitedUseProducts',
  MODE: 'mode',
  MODIFIED_DOWNLOAD_INITIATED: 'modifiedDownloadInitiated',
  NOTES: 'notes',
  PROJECT_CODE: 'projectCode',
  // use the below query key as the first value for any react-query that should be removed on modal close
  REMOVE_QUERY_ON_MODAL_CLOSE: 'removeQueryOnModalClose',
  STATUS: 'status',
  FORM_VALIDATION_ERROR: 'formValidationError',
  ORIGINAL_SIZE: 'originalSize',
  USE_DOWNLOAD_ACTION: 'useDownloadAction',
};
